import {} from 'interfaces/itemsRequest/ItemsRequest';
import ItemsRequestService, {} from 'services/itemsRequestService';
export const makeItemsRequest = async (request) => ItemsRequestService.makeItemsRequest(request);
